// src/api/documents.js
// Hit the backend directly to avoid CRA proxy resets on multipart uploads.

const API_ORIGIN =
  process.env.REACT_APP_API_URL || 'https://api.beemtech.co.uk';

const API_BASE = `${API_ORIGIN}/api/documents`;

function getToken() {
  return localStorage.getItem('accessToken') || null;
}

// Upload with FormData (do NOT set Content-Type)
export async function uploadDocumentFile(file) {
  const token = getToken();
  const fd = new FormData();
  fd.append('file', file);

  const res = await fetch(`${API_BASE}/upload`, {
    method: 'POST',
    body: fd,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let body = null;
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = { error: text };
    }
    const err = new Error(body?.error || `${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return res.json();
}

export async function createDocument(payload) {
  const token = getToken();
  const res = await fetch(`${API_BASE}`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let body = null;
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = { error: text };
    }
    const err = new Error(body?.error || `${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return res.json();
}

export async function listDocuments() {
  const token = getToken();
  const res = await fetch(`${API_BASE}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function deleteDocument(id) {
  const token = getToken();
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function getDocumentOpenUrl(id) {
  const token = getToken();
  const res = await fetch(`${API_BASE}/${id}/open`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let body = null;
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = { error: text };
    }
    const err = new Error(body?.error || `${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  const body = await res.json();
  return body?.url || '';
}

export async function assignDocument(id, tenantId) {
  const token = getToken();
  const res = await fetch(`${API_BASE}/${id}/assign`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ tenantId }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let body = null;
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = { error: text };
    }
    const err = new Error(body?.error || `${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return res.json();
}
